/* ==========================================================================
   OUTLYRS CLUB — product-form.js
   <product-form> custom element: variant selection (price, availability, media,
   URL, disabled combinations) + AJAX add-to-cart with graceful fallback.
   ========================================================================== */
(function () {
  "use strict";

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector("form");
      this.idInput = this.querySelector("[data-variant-id]");
      this.priceTarget = this.querySelector("[data-price-target]");
      this.addButton = this.querySelector("[data-add-button]");
      this.addLabel = this.addButton ? this.addButton.querySelector("[data-add-label]") : null;
      this.atcPrice = this.querySelector("[data-atc-price]");
      this.atcPriceWrap = this.querySelector("[data-atc-price-wrap]");
      this.availability = this.querySelector("[data-availability]");
      this.errorTarget = this.querySelector("[data-form-error]");
      this.optionInputs = Array.prototype.slice.call(this.querySelectorAll("[data-option-value]"));

      try {
        var dataEl = this.querySelector("[data-product-variants]");
        this.variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      } catch (e) { this.variants = []; }

      this.defaultAddText = this.addLabel ? this.addLabel.textContent : "Add to cart";

      this.optionInputs.forEach(function (input) {
        input.addEventListener("change", this.onOptionChange.bind(this));
      }, this);

      if (this.form) this.form.addEventListener("submit", this.onSubmit.bind(this));

      this.updateDisabledOptions();
    }

    getSelectedOptions() {
      var fieldsets = Array.prototype.slice.call(this.querySelectorAll("[data-option-index]"));
      if (!fieldsets.length) {
        return this.variants.length ? this.variants[0].options : [];
      }
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector("[data-option-value]:checked");
        return checked ? checked.value : null;
      });
    }

    findVariant(selected) {
      return this.variants.find(function (v) {
        return v.options.length === selected.length && v.options.every(function (o, i) { return o === selected[i]; });
      });
    }

    onOptionChange() {
      this.updateDisabledOptions();
      var selected = this.getSelectedOptions();
      var variant = this.findVariant(selected);
      this.updateForVariant(variant, selected);
    }

    updateForVariant(variant, selected) {
      var fieldsets = this.querySelectorAll("[data-option-index]");
      fieldsets.forEach(function (fs, i) {
        var label = fs.querySelector("[data-selected-value]");
        if (label && selected[i] != null) label.textContent = selected[i];
      });

      if (!variant) {
        if (this.addButton) this.addButton.setAttribute("disabled", "");
        if (this.addLabel) this.addLabel.textContent = (this.addButton && this.addButton.getAttribute("data-unavailable-text")) || "Unavailable";
        if (this.atcPriceWrap) this.atcPriceWrap.style.display = "none";
        return;
      }

      if (this.idInput) this.idInput.value = variant.id;
      if (this.priceTarget) {
        this.priceTarget.innerHTML = variant.compare_html
          ? '<span class="price price--on-sale"><span class="price__sale">' + variant.price_html + '</span> <s class="price__compare">' + variant.compare_html + "</s></span>"
          : '<span class="price"><span class="price__regular">' + variant.price_html + "</span></span>";
      }

      if (variant.available) {
        if (this.addButton) this.addButton.removeAttribute("disabled");
        if (this.addLabel) this.addLabel.textContent = this.defaultAddText;
        if (this.atcPrice) this.atcPrice.innerHTML = variant.price_html;
        if (this.atcPriceWrap) this.atcPriceWrap.style.display = "";
        if (this.availability) { this.availability.textContent = this.availability.getAttribute("data-in-stock") || "In stock"; this.availability.classList.remove("product__availability--out"); }
      } else {
        if (this.addButton) this.addButton.setAttribute("disabled", "");
        if (this.addLabel) this.addLabel.textContent = (this.addButton && this.addButton.getAttribute("data-soldout-text")) || "Sold out";
        if (this.atcPriceWrap) this.atcPriceWrap.style.display = "none";
        if (this.availability) { this.availability.textContent = this.availability.getAttribute("data-out-stock") || "Sold out"; this.availability.classList.add("product__availability--out"); }
      }

      if (variant.id && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        history.replaceState({}, "", url.toString());
      }

      if (variant.media_id) {
        this.dispatchEvent(new CustomEvent("variant:media", { bubbles: true, detail: { mediaId: variant.media_id } }));
      }
      document.dispatchEvent(new CustomEvent("variant:change", { detail: { variant: variant } }));
    }

    updateDisabledOptions() {
      var fieldsets = Array.prototype.slice.call(this.querySelectorAll("[data-option-index]"));
      var current = this.getSelectedOptions();
      fieldsets.forEach(function (fs, index) {
        var inputs = Array.prototype.slice.call(fs.querySelectorAll("[data-option-value]"));
        inputs.forEach(function (input) {
          var trial = current.slice();
          trial[index] = input.value;
          var match = this.variants.find(function (v) {
            return v.options.every(function (o, i) {
              if (i === index) return o === input.value;
              return trial[i] == null || o === trial[i];
            });
          });
          var available = match && match.available;
          var label = input.nextElementSibling;
          if (label) label.classList.toggle("vpick__label--soldout", !available);
        }, this);
      }, this);
    }

    onSubmit(event) {
      event.preventDefault();
      if (!this.form || (this.addButton && this.addButton.hasAttribute("disabled"))) return;
      this.clearError();
      this.setLoading(true);

      var body = new FormData(this.form);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

      fetch(root + "cart/add.js", {
        method: "POST",
        headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" },
        body: body
      })
        .then(function (res) {
          return res.json()
            .catch(function () { return {}; })
            .then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
        })
        .then(function (result) {
          if (!result.ok) {
            var d = result.data || {};
            var msg = d.description || d.message || "Could not add to cart.";
            this.showError(msg);
            this.logFailure({ stage: "add", status: result.status, message: msg, body: d });
            return;
          }
          document.dispatchEvent(new CustomEvent("cart:added", { detail: { item: result.data } }));
          this.refreshCartCount();
        }.bind(this))
        .catch(function (err) {
          this.showError("Network error. Please try again.");
          this.logFailure({ stage: "network", message: err && err.message ? err.message : String(err) });
        }.bind(this))
        .finally(function () { this.setLoading(false); }.bind(this));
    }

    refreshCartCount() {
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll("[data-cart-count]").forEach(function (el) { el.textContent = "(" + cart.item_count + ")"; });
          document.querySelectorAll("[data-cart-count-mobile]").forEach(function (el) { el.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
        })
        .catch(function () {});
    }

    setLoading(state) {
      if (!this.addButton) return;
      this.addButton.classList.toggle("btn--loading", state);
      this.addButton.setAttribute("aria-busy", state ? "true" : "false");
    }

    /* Records the last add-to-cart failure so it can be inspected after the
       fact: console for anyone watching, sessionStorage for a later report. */
    logFailure(detail) {
      try {
        var entry = {
          when: new Date().toISOString(),
          url: window.location.href,
          variant: this.idInput ? this.idInput.value : null,
          ua: navigator.userAgent
        };
        for (var k in detail) { if (Object.prototype.hasOwnProperty.call(detail, k)) entry[k] = detail[k]; }
        console.error("[Outlyrs] Add to cart failed", entry);
        sessionStorage.setItem("oc_last_cart_error", JSON.stringify(entry));
      } catch (e) {}
    }

    showError(message) {
      if (this.errorTarget) { this.errorTarget.textContent = message; this.errorTarget.hidden = false; }
    }
    clearError() {
      if (this.errorTarget) { this.errorTarget.textContent = ""; this.errorTarget.hidden = true; }
    }
  }

  if (!customElements.get("product-form")) customElements.define("product-form", ProductForm);
})();
